import React, { useEffect, useRef, useState } from "react";
import { Alert, Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import Select from 'react-select';
import * as manualOrdersCrud from './manualOrdersCrud'
import * as helpersCrud from '../Sales/_redux/helpers/helpersCrud'


export const isValidEmail = (email) => {
  // Regex simple y robusta para la mayoría de casos
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).trim());
};
export const business_unit_options= [
    {value:1, label:'SHOPDROFAR'},
    {value:2, label:'ENFANT'},
    {value:3, label:'MI_TEST'},
]
export const motive_options= [
    {value:'publicidad', label:'Publicidad'},
    {value:'venta_ml', label:'Venta mercado libre'},
    {value:'reclamo', label:'Compensación por reclamo'},
    {value:'otro', label:'Otro'},
]
export const shipping_method_options= [
    {value:1, label:'Envio standard', method_id:'free_shipping'},
    {value:2, label:'Envio express', method_id:'free_shipping'},
    {value:3, label:'Retiro en farmacia', method_id:'local_pickup'},
    // {value:5, label:'Sin envio'}
]

export const payment_method_options= [
    {value:1, label:'Pago Online'},
    {value:2, label:'Pago Efectivo'}
]

export function NewOrderDialog({ show, onHide, onSave }) {
    const [loadingProductos, setLoadingProductos] = useState(false);
    const [error, setError] = useState({});
    const [lineItems, setLineItems] = useState([]);
    const [manualOrder, setManualOrder] = useState({})
    const ref = useRef();
    // Opciones para los selects (se cargan del backend)
    const [products, setProducts] = useState([]);
    const [states, setStates] = useState([]);
    const [localities, setLocalities] = useState([]);

    // Estado temporal para agregar producto
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [productQuantity, setProductQuantity] = useState(1);

    const loadStates = async()=>{
        let resp = await helpersCrud.getStates();
        if(resp?.data?.results){
            const _states = resp.data.results.map(s=>({...s, label:s.name, value:s.id}))
            setStates(_states)
        }

        // helpersCrud.getLocalities({filter:{state_id:e.value}}).then(response=>{
        //     const localities = response.data.results.map(item=>({label:item.name, value:item.id}))
        //     setGeoLocalities(localities);
        // })
    }

    useEffect(() => {
        if (show) {
            resetForm();
            // loadProducts();
            loadCountries();
        }
    }, [show]);

    const resetForm = () => {
        setManualOrder({
            motive:motive_options[0],
            business_unit: business_unit_options[0]
        })
        setLineItems([]);
        setSelectedProduct(null);
        setProductQuantity(1);
    };


    const handleSearch = async(query) => {
        try{
            setLoadingProductos(true);    
            const op = await manualOrdersCrud.getAllProducts({ filter:{text:query, source_id: manualOrder.business_unit?.value}})
            if(op && op.data && op.data.results)
                setProducts(op.data.results)
            else
                setProducts([])
            setLoadingProductos(false)
    
        }
        catch(err){
            console.log(err)
            setLoadingProductos(false)

        }
    };
    const onChangeProduct = (value)=>{
        setSelectedProduct(value[0])
    }

    const filteredProducts = products.filter( p => !lineItems.some(s => +s.product_id == +p.origin_id) );

    const loadCountries = async () => {
        // TODO: llamar al backend
        // const response = await getCountries();
        // setCountries(response.data.map(c => ({ value: c.code, label: c.name })));
    };

    const loadLocalities = async (stateId) => {
        let resp = await helpersCrud.getLocalities({filter:{state_id:stateId}});
        if(resp?.data?.results){
            const _locality = resp.data.results.map(s=>({...s, label:s.name, value:s.id}))
            setLocalities(_locality)
        }
    };

    const handleStateChange = (option) => {
        setManualOrder({ 
            ...manualOrder, 
            state: option, 
            locality: null 
        });
        if (option?.value) {
            loadLocalities(option.value);
        } else {
            setLocalities([]);
        }
    };

    const handleAddProduct = () => {
        if (!selectedProduct || productQuantity < 1) return;

        const newItem = {
            product_id: selectedProduct.origin_id,
            product_name: selectedProduct.name,
            quantity: productQuantity,
            price: ''
        };
        ref.current.clear()
        setLineItems([...lineItems, newItem]);
        setSelectedProduct(null);
        setProducts([])
        setProductQuantity(1);
    };

    const handleRemoveProduct = (index) => {
        setLineItems(lineItems.filter((_, i) => i !== index));
    };

    const handlePriceChange = (index, value) => {
        if (value !== '' && !/^\d*\.?\d{0,2}$/.test(value)) return; // bloquea letras/negativos/inválidos
        setLineItems(lineItems.map((item, i) => i === index ? { ...item, price: value } : item));
    };

    const handleShippingMethodChange = (option) => {
        setManualOrder({
            ...manualOrder,
            shipping_method:option,
            costo_envio: 0 //option.value==3 ? 0 : manualOrder.costo_envio // farmacia costo 0
        });
    };
    const handlePaymentMethodChange = (option) => {
        setManualOrder({
            ...manualOrder,
            payment_method: option
        });
    };
    const handleShippingCostChange = (e) => {
        setManualOrder({ ...manualOrder, shipping_cost: e.target.value })
    }

    const validate = ()=>{
            let isValid = true;
            const errores = {};
            console.log(manualOrder)
            if(!isValidEmail(manualOrder?.email)) errores.email=true
            if(!manualOrder.shipping_postcode || manualOrder.shipping_postcode?.trim()=='') errores.shipping_postcode=true
            if(!manualOrder.locality || manualOrder.locality?.name?.trim()=='') errores.locality=true

            if (Object.keys(errores).length > 0) isValid = false;

            setManualOrder({...manualOrder, errores})

            return isValid;
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if(!validate()){
            return
        }
        // if(manualOrder.shipping_cost && manualOrder.shipping_cost.trim()!=''){
        //     if(isNaN(manualOrder.shipping_cost)){
        //         _error.shipping_cost=true
        //     }
        //     else{
        //         _error.shipping_cost=false
        //     }
        // }


        if(lineItems<=0){
            setManualOrder({...manualOrder, errores:{...manualOrder.errores}, detalle: true})
            return
        }

        const faltaPrecio = lineItems.some(
            item => item.price === '' || item.price === null || item.price === undefined
        );
        if (faltaPrecio) {
            setError({ ...error, precio: true });
            return;
        }

        const orderData = {
            payment_method_id: manualOrder.payment_method?.value ,
            payment_method_title: manualOrder.payment_method?.label ,
            billing_dni: manualOrder.billing_dni,
            shipping_first_name: manualOrder.first_name,
            shipping_last_name: manualOrder.last_name,
            shipping_address_1: manualOrder.address_1,
            shipping_city: manualOrder.locality?.name,
            shipping_country: manualOrder.state?.name ,
            shipping_method_id: manualOrder.shipping_method?.method_id ,
            shipping_method_title: manualOrder.shipping_method?.label ,
            shipping_total: 0 ,
            shipping_email: manualOrder.email ,
            shipping_postcode: manualOrder.shipping_postcode ,
            set_paid: false,
            status: "Borrador",
            business_unit_id: manualOrder.business_unit.value, 
            motive: manualOrder.motive.value,
            observations: manualOrder.observations ,
            line_items: lineItems.map(item => ({
                product_id: item.product_id,
                quantity: item.quantity,
                price: Number(item.price) || 0
            })),
        };


        onSave(orderData);

    };

    useEffect(()=>{
        if(show){
            loadStates()
            setError({})
        }
    }, [show])

    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="new-order-modal"
            size="xl"
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title id="new-order-modal">
                    Nuevo Pedido Manual
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>

                {error?.detalle && (
                    <Alert variant="danger" onClose={() => setError({})} dismissible>
                        {"Debe seleccionar al menos un artículo"}
                    </Alert>
                )}
                {error?.precio && (
                    <Alert variant="danger" onClose={() => setError({})} dismissible>
                        {"Debe cargar el precio de todos los artículos"}
                    </Alert>
                )}
                <Form onSubmit={handleSubmit} noValidate>
                    <Row>
                        <Col md={3}>
                            <Form.Group>
                                <Form.Label>Unidad de negocio</Form.Label>
                                <Select
                                    options={business_unit_options}
                                    onChange={ev=>{
                                        setManualOrder({...manualOrder, business_unit:ev});
                                        setLineItems([]);
                                        setSelectedProduct(null);
                                        setProducts([]);
                                        if (ref.current) ref.current.clear();
                                    }}
                                    value={manualOrder.business_unit || business_unit_options[0]}
                                    placeholder=""
                                    // isDisabled={true}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group>
                                <Form.Label>Motivo del pedido</Form.Label>
                                <Select
                                    options={motive_options}
                                    onChange={ev=>setManualOrder({...manualOrder, motive:ev})}
                                    value={manualOrder.motive || motive_options[0]}
                                    placeholder=""
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Nombre</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={manualOrder.first_name}
                                    onChange={(e) => setManualOrder({ ...manualOrder, first_name: e.target.value })}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Apellido</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={manualOrder.last_name}
                                    onChange={(e) => setManualOrder({ ...manualOrder, last_name: e.target.value })}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    className={`${manualOrder?.errores?.email ? "border border-danger" : ""}`}
                                    type="text"
                                    value={manualOrder.email || ""}
                                    onChange={(e) => {                                        
                                        setManualOrder({ ...manualOrder, email: e.target.value, errores:{...manualOrder.errores, email:false} })}
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>DNI</Form.Label>
                                <Form.Control
                                    className={`${manualOrder?.errores?.billing_dni ? "border border-danger" : ""}`}
                                    type="text"
                                    value={manualOrder.billing_dni || ""}
                                    onChange={(e) => {                                        
                                        setManualOrder({ ...manualOrder, billing_dni: e.target.value, errores:{...manualOrder.errores, billing_dni:false}})}
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>                    
                    {/* DATOS DE DOMICILIO */}
                    <h6 className="font-weight-bold mb-3">Datos de domicilio</h6>
                    <Row>
                        <Col md={12}>
                            <Form.Group>
                                <Form.Label>Dirección</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={manualOrder.address_1}
                                    onChange={(e) => setManualOrder({ ...manualOrder, address_1: e.target.value })}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={5}>
                            <Form.Group>
                                <Form.Label>Provincia</Form.Label>
                                <Select
                                    options={states}
                                    onChange={handleStateChange}
                                    value={manualOrder.state || null}
                                    placeholder=""
                                    isClearable
                                />
                            </Form.Group>
                        </Col>
                        <Col md={5}>
                            <Form.Group>
                                <Form.Label>Localidad</Form.Label>
                                <Select
                                    options={localities}
                                    onChange={(option) => setManualOrder({ ...manualOrder, locality: option, errores:{...manualOrder.errores, locality:false} })}
                                    value={manualOrder.locality || null}
                                    placeholder=""
                                    isClearable
                                    isDisabled={!manualOrder.state}
                                    className={`${manualOrder?.errores?.locality ? "border border-danger" : ""}`}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={2}>
                            <Form.Group>
                                <Form.Label>CP</Form.Label>
                                <Form.Control
                                    maxLength={4}
                                    type="text"
                                    value={manualOrder.shipping_postcode}
                                    onChange={(ev) =>{ 
                                        let value = ev.target.value;
                                        value = value.replace(/[^0-9.]/g, '');
                                        setManualOrder({ ...manualOrder, shipping_postcode: value, errores:{...manualOrder.errores, shipping_postcode:false} })}
                                    }
                                    className={`${manualOrder?.errores?.shipping_postcode ? "border border-danger" : ""}`}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {/* ENVÍO Y PAGO */}
                    {/* <h6 className="font-weight-bold mb-3">Envío y Pago</h6> */}
                    <h6 className="font-weight-bold mb-3">Envío</h6>
                    <Row>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Método de Envío</Form.Label>
                                <Select
                                    options={shipping_method_options}
                                    onChange={handleShippingMethodChange}
                                    value={ manualOrder.shipping_method || null}
                                    placeholder="Seleccionar..."
                                    isClearable
                                />
                            </Form.Group>
                        </Col>
                        {/* <Col md={4}>
                            <Form.Group>
                                <Form.Label>Costo de Envío</Form.Label>
                                <Form.Control
                                    className={`${error?.shipping_cost ? "border border-danger" : ""}`}
                                    type="text"
                                    value={manualOrder.shipping_cost || ""}
                                    onChange={handleShippingCostChange}
                                    maxLength={10}
                                    disabled={manualOrder.shipping_method?.value==3}
                                />
                            </Form.Group>
                        </Col> */}
                        {/* <Col md={4}>
                            <Form.Group>
                                <Form.Label>Método de Pago</Form.Label>
                                <Select
                                    options={payment_method_options}
                                    onChange={handlePaymentMethodChange}
                                    value={manualOrder.payment_method || null}
                                    placeholder="Seleccionar..."
                                    isClearable
                                />
                            </Form.Group>
                        </Col> */}
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Observaciones</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={manualOrder.observations || ""}
                                    onChange={(e) => {                                        
                                        setManualOrder({ ...manualOrder, observations: e.target.value })}
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>       
                    {/* PRODUCTOS */}
                    <h6 className="font-weight-bold mb-3">Productos</h6>
                    <Row className="align-items-end">
                        <Col md={6}>
                            <Form.Group>
                                <AsyncTypeahead
                                    id="buscadorProductos"
                                    ref={ref}
                                    className='mr-6'
                                    highlightOnlyResult={false}
                                    renderMenuItemChildren={(option) => (
                                            <span>{option.name}</span>
                                        )}
                                    isLoading={loadingProductos}
                                    minLength={3}
                                    labelKey={option => `${option.name}`}
                                    onSearch={handleSearch}
                                    options={filteredProducts}
                                    filterBy={['name', 'sku']}
                                    prompText='Escribe para buscar productos'
                                    searchText='Buscando...'
                                    placeholder='Escribe para buscar productos'
                                    onChange={onChangeProduct}
                                    useCache={false}
                                />
                            </Form.Group>
                            {/* <Form.Group>
                                <Form.Label>Producto</Form.Label>
                                <Select
                                    options={products}
                                    onChange={setSelectedProduct}
                                    value={selectedProduct}
                                    placeholder="Buscar producto..."
                                    isClearable
                                />
                            </Form.Group> */}
                        </Col>
                        <Col md={3}>
                            <Form.Group>
                                <Form.Label>Cantidad</Form.Label>
                                <Form.Control
                                    type="number"
                                    min="1"
                                    value={productQuantity}
                                    onChange={(e) => setProductQuantity(parseInt(e.target.value) || 1)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group>
                                <Button
                                    variant="success"
                                    onClick={handleAddProduct}
                                    disabled={!selectedProduct}
                                    className="w-100"
                                >
                                    Agregar
                                </Button>
                            </Form.Group>
                        </Col>
                    </Row>

                    {lineItems.length > 0 && (
                        <Table size="sm" className="table table-head-custom table-vertical-center overflow-hidden">
                            <thead>
                                <tr>
                                    <th>Producto</th>
                                    <th style={{ width: '100px' }}>Cantidad</th>
                                    <th style={{ width: '150px' }}>Precio unitario</th>
                                    <th style={{ width: '120px' }}>Subtotal</th>
                                    <th style={{ width: '80px' }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {lineItems.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.product_name}</td>
                                        <td>{item.quantity}</td>
                                        <td>
                                            <Form.Control
                                                type="text"
                                                inputMode="decimal"
                                                placeholder="0.00"
                                                className={error?.precio && (item.price === '' || item.price == null) ? "border border-danger" : ""}
                                                value={item.price ?? ''}
                                                onChange={(e) => handlePriceChange(index, e.target.value)}
                                            />
                                        </td>
                                        <td>{((Number(item.price) || 0) * item.quantity).toFixed(2)}</td>
                                        <td className="text-center">
                                            <Button className="btn btn-icon btn-light btn-hover-danger btn-sm mr-2"
                                                onClick={() => handleRemoveProduct(index)} >
                                                <span><i className="fas fa-trash text-danger"></i></span>
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}


                    <div className="text-right mt-10">
                        <Button variant="default" type="button" onClick={onHide} className="mr-2">
                            Cancelar
                        </Button>
                        <Button variant="primary" type="submit">
                            Crear Pedido
                        </Button>
                    </div>

                </Form>
            </Modal.Body>
        </Modal>
    );
}
